(function () {
  var DAY = 86400000;
  var HOUR = 3600000;
  var MINUTE = 60000;

  function parseTarget(raw) {
    if (!raw) return NaN;
    // 没有写时区标记时按 UTC 处理，避免跨浏览器解析差异
    if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)) {
      raw += 'Z';
    }
    return new Date(raw).getTime();
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function setNum(banner, unit, value) {
    var el = banner.querySelector('[data-unit="' + unit + '"]');
    var text = pad(value);
    // 只在数字变化时写 DOM，减少每秒的重排
    if (el && el.textContent !== text) el.textContent = text;
  }

  function hideBanner(banner) {
    var section = banner.closest('.shopify-section');
    (section || banner).hidden = true;
  }

  // 返回 true 表示这条已经结束，不需要再计时
  function render(banner, now) {
    var target = parseTarget(banner.getAttribute('data-countdown-end'));
    if (isNaN(target)) return true;

    var diff = target - now;
    if (diff <= 0) {
      if (banner.hasAttribute('data-hide-on-end')) {
        hideBanner(banner);
      } else {
        ['days', 'hours', 'minutes', 'seconds'].forEach(function (unit) {
          setNum(banner, unit, 0);
        });
        banner.classList.add('is-final-day');
      }
      return true;
    }

    var days = Math.floor(diff / DAY);
    setNum(banner, 'days', days);
    setNum(banner, 'hours', Math.floor((diff % DAY) / HOUR));
    setNum(banner, 'minutes', Math.floor((diff % HOUR) / MINUTE));
    setNum(banner, 'seconds', Math.floor((diff % MINUTE) / 1000));
    banner.classList.toggle('is-final-day', days === 0);
    return false;
  }

  var intervalId = null;

  function initPromoCountdown() {
    if (intervalId) clearInterval(intervalId);
    intervalId = null;

    var banners = Array.prototype.slice.call(
      document.querySelectorAll('.promo-banner[data-countdown-end]')
    );
    if (!banners.length) return;

    function tick() {
      // 每次都按当前时间重新算，标签页切回前台也不会漂移
      var now = Date.now();
      banners = banners.filter(function (banner) {
        return !render(banner, now);
      });
      if (!banners.length && intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    tick();
    if (banners.length) intervalId = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoCountdown);
  } else {
    initPromoCountdown();
  }

  // Theme Editor 里改设置会重新渲染 section，需要重新绑定
  document.addEventListener('shopify:section:load', initPromoCountdown);
})();
